import { Injectable } from '@angular/core';

declare var gtag;

@Injectable({
  providedIn: 'root',
})
export class ProfileAnalyticsService {
  constructor() {}

  analyticProfileVisited() {
    gtag('event', 'profile_visited', {
      event_category: 'Profile Events',
    });
  }

  analyticProfileDietHistoryVisited() {
    gtag('event', 'profile_diet_history_visited', {
      event_category: 'Profile Events',
    });
  }

  analyticProfileWeightHistoryVisited() {
    gtag('event', 'profile_weight_history_visited', {
      event_category: 'Profile Events',
    });
  }

  analyticProfileWaterHistoryVisited() {
    gtag('event', 'profile_water_history_visited', {
      event_category: 'Profile Events',
    });
  }
}
